(() => {
  const normalize = (value) =>
    String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  const initialize = (root) => {
    if (!root || root.dataset.swFaqReady === "true") return;

    const input = root.querySelector("[data-sw-faq-search]");
    const clear = root.querySelector("[data-sw-faq-clear]");
    const status = root.querySelector("[data-sw-faq-status]");
    const empty = root.querySelector("[data-sw-faq-empty]");
    const items = [...root.querySelectorAll("[data-sw-faq-item]")];
    const categories = [...root.querySelectorAll("[data-sw-faq-category]")];
    const topics = [...root.querySelectorAll("[data-sw-faq-topic]")];

    if (!input || !status || !items.length) return;

    root.dataset.swFaqReady = "true";

    items.forEach((item) => {
      const category = item.closest("[data-sw-faq-category]");
      item.dataset.searchText = normalize(
        `${category?.dataset.categoryLabel || ""} ${item.textContent}`
      );
    });

    const update = () => {
      const rawQuery = input.value.trim();
      const query = normalize(rawQuery);
      let visibleItems = 0;
      let visibleCategories = 0;

      items.forEach((item) => {
        const matches = !query || item.dataset.searchText.includes(query);
        item.hidden = !matches;
        if (matches) visibleItems += 1;
      });

      categories.forEach((category) => {
        const categoryItems = [...category.querySelectorAll("[data-sw-faq-item]")];
        const hasMatch = categoryItems.some((item) => !item.hidden);
        category.hidden = !hasMatch;
        if (hasMatch) visibleCategories += 1;
      });

      topics.forEach((topic) => {
        const category = categories.find(
          (entry) => entry.dataset.swFaqCategory === topic.dataset.swFaqTopic
        );
        topic.hidden = Boolean(query) && (!category || category.hidden);
      });

      if (clear) clear.hidden = !rawQuery;
      if (empty) empty.hidden = visibleItems > 0;

      if (!rawQuery) {
        status.textContent = `${items.length} answers across ${categories.length} topics`;
      } else if (visibleItems === 1) {
        status.textContent = `1 answer found for “${rawQuery}”`;
      } else {
        status.textContent = `${visibleItems} answers found for “${rawQuery}”`;
      }

      root.classList.toggle("is-searching", Boolean(query));
      root.dataset.visibleCategories = String(visibleCategories);
    };

    input.addEventListener("input", update);

    clear?.addEventListener("click", () => {
      input.value = "";
      update();
      input.focus();
    });

    update();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-sw-faq]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
